/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2020-03-23 14:35:45
 * @LastEditors: soul(佘家骏) 
 * @LastEditTime: 2022-05-10 11:52:28
 * @Description: 
 * 
 * 注意：此方法支持import 和 .vue单文件中style。暂不支持style中使用@import url();
 */
const baseSize = 16
function setRem() {
  const scale = document.documentElement.clientWidth / 375
  document.documentElement.style.fontSize = (baseSize * Math.min(scale, 2)) + 'px'
}
setRem()
window.onresize = function () {
  setRem()
}
